import React, { useEffect, useState } from "react";
import "jsvectormap/dist/maps/world.js";
import "jsvectormap/dist/css/jsvectormap.min.css";
import {
  Card,
  CardBody,
  CardHeader,
} from "./../components/card/card.jsx";
import { useDispatch, useSelector } from "react-redux";
import { openDetail, openImage, openPDF } from "../redux/slice/leanSlice";
import { getLeanPage } from "../redux/action/leanAction.js";
import ConvertImage from "../components/ConvertImage.jsx";
import { InputNonForm, SelectNonForm } from "../components/InputComponent.jsx";
import PopupPDFLean from "./PDF/PopupPDFLean.jsx";
import { getSitesList, getSitesPage } from "../redux/action/sitesAction.js";
import ButtonComponent from "../components/ButtonComponent.jsx";
import moment from 'moment'
import { useLocation } from "react-router-dom";
import { getRoleModuleById } from "../redux/action/roleModuleAction.js";
import findItem from "../helperFindPath.js";
import DetailDataTableComponent from "../components/DetailDatatableComponent.jsx";
import DetailLaporanLean from "./DetailLaporan/DetailLaporanLean.jsx";

function LeanDetection() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0)
  const [sort, setSort] = useState('')
  const [select, setSelect] = useState('')
  const [filter, setFilter] = useState('')
  const countPerPage = 10
  const { dataLean, isOpenImageLean, dataByIdLean, idLean, isOpenPDF } = useSelector((state) => state.lean);
  const { dataSitesList } = useSelector( (state) => state.sites );
  const [filterWaktu, setFilterWaktu] = useState('')
  const [filterSites, setFilterSites] = useState('')
  const [optionSites, setOptionSites] = useState([])
  const [filterStartDate, setFilterStartDate] = useState(moment().format('YYYY-MM-DD'))
  const [filterEndDate, setFilterEndDate] = useState(moment().format('YYYY-MM-DD'))
  const [filterStartMonth, setFilterStartMonth] = useState(moment().format('YYYY-MM'))
  const [filterStartYear, setFilterStartYear] = useState(moment().format('YYYY'))
  const { user } = useSelector((state) => state.auth)
  const param = {
    token: user.access_token,
    filter: {
      waktu: filterWaktu,
      siteId: filterSites,
      date: filterStartDate,
      endDaily: filterEndDate,
      month: filterStartMonth,
      year: filterStartYear,
    },
    sort: sort,
    size: countPerPage,
    select: select,
    page: page,
  }
  const newSites = () => {
    // console.log(dataSupervisor)
    let arr = [{ name: '- PILIH LOKASI JPO -', id: '' }]
    dataSitesList.map((row, index) => {
      arr.push({ name: row.siteName, id: row.siteId })
    })
    setOptionSites(arr)
  }
  useEffect(() => {
    newSites()
  }, [])
  useEffect(() => {
    if (dataSitesList.length > 0) {
      newSites()
    }
  }, [dataSitesList])
  useEffect(() => {
    dispatch(getLeanPage(param));
    // eslint-disable-next-line
  }, [filterSites, filterWaktu, filterStartDate, filterEndDate, filterStartMonth, filterStartYear]);
  useEffect(() => {
    dispatch(getSitesList(param));
  }, []);

  const onChange = async (e, field) => {
    // console.log(e.target.value)
    if (field === 'siteId') {
      setFilterSites(e.target.value)
    }
    if (field === 'waktu') {
      setFilterWaktu(e.target.value)
    }
    if (field === 'date') {
      setFilterStartDate(e.target.value)
    }
    if (field === 'month') {
      setFilterStartMonth(e.target.value)
    }
    if (field === 'startYearly') {
      setFilterStartYear(e.target.value)
    }
  }
  const pdfGenerate = async (data, id) => {
    dispatch(openPDF({ open: true }))
  }
  const {dataRoleModuleSidebar, dataByIdRoleModule} = useSelector((state)=>state.roleModule)
  const { pathname } = useLocation();
  const [ dataObjPath, setDataObjPath] = useState('')
  useEffect(() => {
    if(dataObjPath !== ''){
      param.id = dataObjPath.id
      dispatch(getRoleModuleById(param))
    }
    // eslint-disable-next-line
  }, [dataObjPath]);
  useEffect(()=>{
    if(dataRoleModuleSidebar.length > 0){
      const findPath = findItem(dataRoleModuleSidebar, pathname)
      if(findPath !== null){
        setDataObjPath(findPath) 
      }
    }
  },[dataRoleModuleSidebar])

  if(dataByIdRoleModule !== ''){

    if(!dataByIdRoleModule.create && !dataByIdRoleModule.read && !dataByIdRoleModule.update && !dataByIdRoleModule.delete){
      return (
        <div>
          <h2>403: Forbidden</h2>
          <p>Anda Tidak Memiliki Hak Akses Untuk Halaman Ini</p>
        </div>
      )
    }else{

      const columns = [
        {
          name: 'Nama Site',
          selector: (row) => row.siteName,
          sortable: true,
        },
        {
          name: 'Waktu ',
          selector: (row) => row.date,
          sortable: true,
        },
        {
          name: 'Jumlah',
          selector: (row) => row.sum,
          sortable: true,
        },
        {
          name: 'Action',
          cell: (row) => (
            <div style={{ padding: '10px 0' }}>
              <ButtonComponent
                onClick={(e) => dispatch(openDetail({ open: true, id: row.id, data: row }))}
                color="white"
                backgroundColor="#3003fc"
                backgroundHover="#2404b5"
                spacing="5px"
              >
                <i className="fas fa-eye" />
              </ButtonComponent>
            </div>
          ),
        },
      ]    

  return (
    <div>
      <h4> Laporan Pendeteksi Orang Bersandar </h4>
    {dataByIdRoleModule.read ? (
      <div className="row">
        <div className="col-xl-12">
          <Card className="mb-3">
            <CardHeader style={{ borderBottom: "none" }}>
              <div className="row">
                <div className="col-xl-6">
                  <span style={{ fontSize: "1rem" }}> Laporan Pendeteksi Orang Bersandar </span>
                  {/* <span className="text-secondary"> List </span> */}
                </div>
                <div className="col-xl-6" style={{ textAlign: 'right', alignSelf: 'center' }}>
                  <ButtonComponent
                    onClick={() => pdfGenerate()}
                    color="white"
                    backgroundColor="#3003fc"
                    backgroundHover="#2404b5"
                    spacing="5px"
                  >
                    <i className="fas fa-download"> 
                      <span style={{ fontSize: "8px", marginLeft: "5px" }}>
                        Unduh Data
                      </span>
                    </i>
                  </ButtonComponent>
                </div>
              </div>
            </CardHeader>
            <CardBody>
            <div className="row">
              <div className="col-xl-4" style={{ textAlign: 'right', alignSelf: 'center' }}>
                <SelectNonForm 
                  onChange={(e) => {
                    setFilterSites(e.target.value)
                  }}
                  name="type"
                  id="type"
                  value={filterSites}
                  option={optionSites}  
                />
              </div>
              <div className="col-xl-4" style={{ textAlign: 'right', alignSelf: 'center' }}>
                <SelectNonForm 
                  onChange={(e) => onChange(e, 'waktu')}
                  name="type"
                  id="type"
                  value={filterWaktu}
                  option={[
                    { name: 'PILIH PERIODE', id: '' },
                    { name: 'Harian', id: 'daily' },
                    { name: 'Bulanan' , id: 'monthly'},
                    { name: 'Tahunan', id: 'yearly' },
                  ]}
                />
              </div>
              {param.filter.waktu === 'daily' ? (
                  <>
                <div className="col-xl-4" style={{ textAlign: 'right', alignSelf: 'center' }}>
                  <InputNonForm
                    type="date"
                    placeholder="Title"
                    value={filterStartDate}
                    onChange={(e) => onChange(e, 'date')}
                    style={{ width: '100%' }}
                    className="form-control form-control-sm"
                  />
                </div>
                </>
                ) : null}
                {param.filter.waktu === 'monthly' ? (
                  <>
                  <div className="col-xl-4" style={{ textAlign: 'right', alignSelf: 'center' }}>
                  <InputNonForm
                    type="month"
                    placeholder="Title"
                    value={filterStartMonth}
                    onChange={(e) => onChange(e, 'month')}
                    style={{ width: '100%' }}
                    className="form-control form-control-sm"
                  />
                  </div>
                  </>
                  ) : null}
                  {param.filter.waktu === 'yearly' ? (
                  <>
                  <div className="col-xl-4" style={{ textAlign: 'right', alignSelf: 'center' }}>
                  <InputNonForm
                    type="year"
                    placeholder="Title"
                    value={filterStartYear}
                    onChange={(e) => onChange(e, 'year')}
                    style={{ width: '100%' }}
                    className="form-control form-control-sm"
                  />
                  </div>
                  </>
                ) : null}
              </div>
              &nbsp;
              <DetailDataTableComponent
                data={dataLean}
                page={page}
                countPerPage={countPerPage}
                columns={columns}
                setPage={setPage}
              />
            </CardBody>
          </Card>
        </div>
      </div>
    ):null}
      {isOpenPDF ? (
        <PopupPDFLean dataLean={dataLean} isOpenPDF={isOpenPDF} filter={filterWaktu}/>
      ) : null}
      <DetailLaporanLean siteId={filterSites} waktu={filterWaktu} startDaily={filterStartDate} />
    </div>
  );
  }
  }
  return (
    <div>
      <h2>403: Forbidden</h2>
      <p>Anda Tidak Memiliki Hak Akses Untuk Halaman Ini</p>
    </div>
  )
}

export default LeanDetection;
